<template>
  <div class="row">
    <!--  申请岗位列表  -->
    <div class="flex xs12">
      <va-card title="申请岗位列表">
        <div class="row align-center mb-1">
          <div class="flex md12 sm6 xs12">
            <va-button-group>
              <va-button class="mb-2" flat disabled color="gray" >处理状态：</va-button>
              <va-button class="mb-2" :color="computeStatusColor(null)" flat  v-on:click="handleStatusChange(null)" >全部</va-button>
              <va-button
                class="mb-2"
                flat
                v-for="status in appliedJobStatusType"
                :key="status.CODE"
                :color="computeStatusColor(status.CODE)"
                v-on:click="handleStatusChange(status.CODE)" >{{status.TEXT}}</va-button>
              <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
            </va-button-group>
          </div>
          <!--    用户uid筛选      -->
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="userUid"
              placeholder="搜索学员UID"
              @input="searchUserUid"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <!--   内推id筛选       -->
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="referralId"
              placeholder="搜索内推ID"
              @input="searchReferralId"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="appliedJobs"
          :loading="loading"
          :totalPages="totalPages"
          class="force-wrap"
          @page-selected="listAppliedJob"
          api-mode
        >
          <template slot="avatar" slot-scope="props">
            <img :src="props.rowData.user.avatar" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="user" slot-scope="props">
            <va-button color="gray" flat small :to='{path:`/admin/users/updateUser/${props.rowData.user.uid}`}'>
              {{ props.rowData.user.nickname }}
            </va-button>
          </template>
          <template slot="referral" slot-scope="props">
            <va-button color="gray" flat small :to='{path:`/admin/referrals/updateReferral/${props.rowData.referral.id}`}'>
              {{ props.rowData.referral.name }}
            </va-button>
          </template>
          <template slot="statusSlot" slot-scope="props">
            <va-badge color= 'info'>
              {{ computeAppliedJobStatus(props.rowData.status).text }}
            </va-badge>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="查看" placement="top">
              <va-button flat small color="gray" icon="fa fa-eye"
                :to='{path:`getAppliedJob/${props.rowData.id}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteId=props.rowData.id"/>
            </va-popover>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除报名"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import appliedJobApi from '../../../api/appliedJob'
import { USER_APPLICATION_STATUS_TYPES } from '../../../utils/constants'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      referralId: this.$route.query.referralId,
      userUid: this.$route.query.userUid,
      appliedJobs: [],
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 0,
      deleteModal: false,
      deleteId: null,
      status: null,
      appliedJobStatusType: USER_APPLICATION_STATUS_TYPES,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:avatar',
          title: '学员头像',
          width: '60px',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:user',
          title: '学员姓名',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:statusSlot',
          title: '处理状态',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:referral',
          title: '内推公司',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '申请时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listAppliedJob()
  },
  methods: {
    listAppliedJob (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        userUid: this.userUid,
        referralId: this.referralId,
        status: this.status,
      }
      appliedJobApi.listAppliedJob(params).then(response => {
        this.appliedJobs = response.appliedJobs
        this.appliedJobs.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => alert(error.msg))
    },
    computeStatusColor (status) {
      return status === this.status ? 'info' : 'gray'
    },
    handleStatusChange (status) {
      this.status = status
      this.listAppliedJob()
    },
    confirmDelete () {
      if (this.deleteId === null) return
      appliedJobApi.deleteAppliedJob(this.deleteId).then(response => {
        if (response.success === true) {
          this.showToast('删除报名成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listAppliedJob()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    searchUserUid: debounce(function (userUid) {
      this.userUid = userUid
      if (this.userUid === '') { this.userUid = null }
      this.listAppliedJob()
    }, 400),
    searchReferralId: debounce(function (referralId) {
      this.referralId = referralId
      if (this.referralId === '') { this.referralId = null }
      this.listAppliedJob()
    }, 400),
    computeAppliedJobStatus (status) {
      const data = {
        text: '',
      }
      this.appliedJobStatusType.map(x => {
        if (x.CODE === status) {
          data.text = x.TEXT
        }
      })
      return data
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
<style lang="scss">
.force-wrap td {
  word-break: break-word; /* 文本行的任意字内断开 */
  word-wrap: break-word; /* IE */
  white-space: -moz-pre-wrap; /* Mozilla */
  white-space: -hp-pre-wrap; /* HP printers */
  white-space: -o-pre-wrap; /* Opera 7 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: pre; /* CSS2 */
  white-space: pre-wrap; /* CSS 2.1 */
  white-space: pre-line; /* CSS 3 (and 2.1 as well, actually) */
}
</style>
